import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import datalayer from "@lab/store/datalayer.module";
import intercomModule from "@lab/store/intercom.module";
import reportQueries from "@lab/store/report.queries.module";
import reportFilters from "@lab/store/report.filters.module";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		...modules,
		datalayer,
		intercomModule,
		reportQueries,
		reportFilters
	}
});

export default store;
